import { Common } from "helpers/common";
import React, { ReactNode, createContext, useContext, useEffect, useState } from "react";

type Props = {
    children?: ReactNode;
}

interface User {
    authToken: string;
    refreshToken: string;
    userId: number;
    businessId: number | null;
    userRoleId: number;
    userRole: string;
    fullName: string;
    email: string;
    documentStatus: string;
    isActive: boolean;
    isPhoneVerified: boolean;
    isEmailVerified: boolean;
}

type IAppContext = {
    permissions: any[];
    setPermissions: (permissions: any[]) => void;

    menus: any[];
    setMenus: (menus: any[]) => void;

    userName: string;
    setUserName: (userName: string) => void;

    userRole: string;
    setUserRole: (userRole: string) => void;

    isSystemAdmin: boolean;
    setIsSystemAdmin: (isSystemAdmin: boolean) => void;

    masterData: any;
    setMasterData: (masterData: any) => void;

    // User authentication
    user: User | null;
    setUser: (user: User | null) => void;
}

const initialValue = {
    permissions: [],
    setPermissions: (permissions: any[]) => { },

    menus: [],
    setMenus: (menus: any[]) => { },

    userName: '',
    setUserName: (userName: string) => { },

    userRole: '',
    setUserRole: (userRole: string) => { },

    isSystemAdmin: false,
    setIsSystemAdmin: (isSystemAdmin: boolean) => { },

    masterData: {},
    setMasterData: (masterData: any) => { },

    // User authentication
    user: null,
    setUser: (user: User | null) => { }
}

export const AppContext = createContext<IAppContext>(initialValue)

export const AppContextProvider = ({ children }: Props) => {
    const [permissions, setPermissionsData] = useState<any[]>([]);
    const [menus, setMenuData] = useState<any[]>([]);
    const [userName, setUserNameData] = useState<any>('');
    const [userRole, setUserRoleData] = useState<any>('');
    const [isSystemAdmin, setIsSystemAdminData] = useState<boolean>(false);
    const [masterData, setMasterListData] = useState<any>({});
    const [user, setUserData] = useState<User | null>(null);

    const setPermissions = (appPermissions: any[]) => {
        console.log('App Context permissions', appPermissions);
        setPermissionsData(appPermissions);
    };

    const setMenus = (appMenus: any[]) => {
        console.log('App Context menus', appMenus);
        setMenuData(appMenus);
    };

    const setUserName = (userName: any) => {
        console.log('App Context user name', userName);
        setUserNameData(userName);
    };

    const setUserRole = (userRole: any) => {
        console.log('App Context user role', userRole);
        setUserRoleData(userRole);
    };

    const setIsSystemAdmin = (isSystemAdmin: boolean) => {
        console.log('App Context isSystemAdmin', isSystemAdmin);
        setIsSystemAdminData(isSystemAdmin);
    };

    const setMasterData = (masterData: any) => {
        console.log('App Context masterData', masterData);
        setMasterListData(masterData);
    };

    const setUser = (userData: User | null) => {
        console.log('App Context user', userData);
        if (userData) {
            setUserData(userData);
        } else {
            setUserData(null);
        }
    };

    const allObj = {
        permissions,
        setPermissions,

        menus,
        setMenus,

        userName,
        setUserName,

        userRole,
        setUserRole,

        isSystemAdmin,
        setIsSystemAdmin,

        masterData,
        setMasterData,

        // User authentication
        user,
        setUser
    };

    useEffect(() => {
        const common = new Common();
        const appPermissions = localStorage.getItem("app-permissions");
        const appMenus = localStorage.getItem("app-menus");
        const appUser = localStorage.getItem("user-name") || 'No User';
        const appRole = localStorage.getItem("IDKS@ROLE");
        const appUserRole = appRole ? common.decrypt(appRole) : 'No Role';
        const appIsSystemAdmin = appUserRole && (appUserRole === "system-admin" || appUserRole === "system-admin") ? true : false;

        // Get user data from localStorage
        const storedUser = localStorage.getItem("user");


        setPermissionsData(appPermissions !== null ? JSON.parse(appPermissions) : []);
        setMenuData(appMenus !== null ? JSON.parse(appMenus) : []);
        setUserNameData(appUser);
        setUserRoleData(appUserRole);
        setIsSystemAdminData(appIsSystemAdmin);

        // Set user data if all required fields are present
        if (storedUser) {
            const userData: User = JSON.parse(storedUser);
            setUserData(userData);
        }

        console.log('App Context useEffect');
    }, [])

    return (
        <AppContext.Provider value={allObj}>
            {children}
        </AppContext.Provider>
    );
}

